/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import moment from 'moment';
import { Campaign } from '../../../../../api';
import useAsset from '../../../../hook/useAsset';

export function getChartWaveLabels(waves: Campaign[]): Record<string, string> {
  const { constants } = useAsset();

  return useMemo(
    () =>
      waves.reduce<Record<string, string>>((acc, wave) => {
        const isRunning = wave.attributes.status === constants.STATUS_ACTIVE;
        const waveDate = moment(wave.attributes.launch_date).format('M/D');
        const xLabel = isRunning ? waveDate + ' (running)' : waveDate;
        return {
          ...acc,
          [wave.attributes.providable_id]: xLabel,
        };
      }, {}),
    [waves, constants]
  );
}
